export enum LostShoppersMessageCode {
  CONVERSION = 'lost-shoppers-conversion',
  NUMBER = 'lost-shoppers-number',
  VALUE = 'lost-shoppers-value',
  AUDIENCE = 'lost-shoppers-shopper-audience',
}

export const getMessageCode = (index?: number): string | null => {
  if (index === undefined) {
    return null;
  }
  return (
    [
      LostShoppersMessageCode.CONVERSION,
      LostShoppersMessageCode.NUMBER,
      LostShoppersMessageCode.VALUE,
      LostShoppersMessageCode.AUDIENCE,
    ][index] || LostShoppersMessageCode.CONVERSION
  );
};
